import clsx from 'clsx';
import React from 'react';
import { Icon } from '../Icon';

import type { LinkListProps, LinkListItemProps } from './LinkList.types';

const LinkListNavItem = ({
  title,
  link,
  text,
  hasDarkTitle,
}: LinkListItemProps): JSX.Element => {
  return (
    <div className='link-list__item'>
      <div className='link-list__body'>
        <a
          href={link}
          className={clsx('link-list__title', {
            'link-list__title_dark': hasDarkTitle,
          })}
        >
          {title}
        </a>
        {text && <div className='link-list__content'>{text}</div>}
      </div>
      <Icon
        icon='ChevronRight'
        className='link-list__icon'
        color='blue'
        size='xlarge'
      />
    </div>
  );
};

export const LinkList = ({
  items,
  hasDarkTitle,
}: LinkListProps): JSX.Element => (
  <div className='link-list'>
    {items.map((listItem, index: number) => (
      <LinkListNavItem key={index} hasDarkTitle={hasDarkTitle} {...listItem} />
    ))}
  </div>
);
